import DataHelper from "../../helpers/data.helper";
import { formatDateTime } from "../../helpers/dateFormat";
import InitPaymentsLogic from "./Payments.logic";

const PaymentsComponent: React.FC = () => {
    const { data, payments, typeNames, onChange, loadPayments } = InitPaymentsLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Pregled uplata</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                    <label htmlFor="fromDate">Od (uključen)</label>
                    <input id="fromDate" type={"date"} value={data.fromDate} onChange={onChange} name="fromDate"></input>
                </div>

                <div>
                    <label htmlFor="toDate">Do (isključen)</label>
                    <input id="toDate" type={"date"} value={data.toDate} onChange={onChange} name="toDate"></input>
                </div>

                <button className="btn-primary" type="button" onClick={loadPayments}>Učitaj</button>
            </div>

            {payments.length > 0 && (
                <h3 className="text-align-center" style={{ marginTop: '16px' }}>Suma: {payments.reduce((acc, obj) => { return acc + obj.price; }, 0)} dinara</h3>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
                {payments.map((p) =>
                    <div className="card text-align-center" key={p.id}>
                        <p style={{ fontWeight: 500, marginBottom: '4px' }}>{formatDateTime(p.date)}</p>
                        <p style={{ margin: '4px 0' }}>{p.client.firstName} {p.client.lastName}</p>
                        <p style={{ margin: '4px 0' }}>{p.quantity}x {typeNames[p.trainingTypeId] ?? DataHelper.trainingTypesIdsTrainingTypes[p.trainingTypeId] ?? ""}</p>
                        <p style={{ fontWeight: 500, marginTop: '8px' }}>{p.price}</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PaymentsComponent;
